import React, { forwardRef, useRef, useState } from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon';
import Loader from '@mollie/ui-assets/icons/utilitarian/Loader';
import { Box } from '../Box';
import { useButtonGroupContext } from '../ButtonGroup';
import { useComposedRefs, useElementSize, useResponsiveProp, } from '../../utils';
import './Button.css';
export const Button = forwardRef(function Button(props, ref) {
    const { size: buttonGroupSize } = useButtonGroupContext();
    const { children, elementType = 'button', loading = false, type = 'button', disabled, href, target, rel, size = buttonGroupSize, variant = 'primary', className, unstyled, transparent, autoFocus, UNSAFE_contentClassName, style, ...rest } = props;
    const responsiveSize = useResponsiveProp(size);
    const buttonRef = useRef(null);
    const [buttonWidth, setButtonWidth] = useState();
    useElementSize(buttonRef, (size) => {
        setButtonWidth('inlineSize' in size ? size.inlineSize : size.width);
    }, 'borderBoxSize');
    let buttonProps;
    if (elementType === 'button') {
        buttonProps = {
            type,
            disabled: disabled || loading,
        };
    }
    else if (typeof elementType === 'string') {
        buttonProps = {
            tabIndex: disabled ? undefined : 0,
            href: elementType === 'a' && disabled ? undefined : href,
            target: elementType === 'a' ? target : undefined,
            type: elementType === 'input' ? type : undefined,
            disabled: elementType === 'input' ? disabled : undefined,
            'aria-disabled': !disabled || elementType === 'input' ? undefined : disabled,
            rel: elementType === 'a' ? rel : undefined,
        };
    }
    else {
        buttonProps = {
            href,
            target,
            type,
            disabled,
            rel,
        };
    }
    return (React.createElement(Box.Restricted, { elementType: elementType, ...buttonProps, ...rest, style: {
            ...style,
            '--mollie-ui-button-calculated-width': buttonWidth,
        }, className: clsx('mollie-ui-button', {
            'mollie-ui-button--small': !responsiveSize && variant === 'icon',
            [`mollie-ui-button--${responsiveSize}`]: responsiveSize,
            [`mollie-ui-button--${variant}`]: variant && variant !== 'primary',
            'mollie-ui-button--loading': loading,
            'mollie-ui-button--unstyled': unstyled,
            'mollie-ui-button--transparent': transparent,
        }, className), ref: useComposedRefs(ref, buttonRef), autoFocus: autoFocus, "data-autofocus": autoFocus },
        loading && (React.createElement("span", { className: "mollie-ui-button-spinner" },
            React.createElement(Icon, { src: Loader, spinning: true }))),
        React.createElement("span", { className: clsx('mollie-ui-button-content', UNSAFE_contentClassName) }, children)));
});
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map